import React from "react";
import { useImmer } from "use-immer";

import { IgDialog, IgTextField, IgTypography } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { usePatchOrganization } from "@src/api/organizations/patch-organization";
import { useDialog } from "@src/hooks/dialog";
import { urlRegex } from "@src/utils/constants";

export const SetDomainDialog = () => {
  const dialog = useDialog("setDomain");
  const [url, setUrl] = useImmer<string>("");
  const [error, setError] = useImmer<boolean>(false);
  const patchOrganization = usePatchOrganization();
  const theme = useTheme();
  const handleChange = (value: string) => {
    setUrl(value);
    if (value.length <= 8 || urlRegex.test(value)) {
      setError(false);
    } else {
      setError(true);
    }
  };

  const handleYesClick = () => {
    patchOrganization.mutate({
      body: {
        domain: url,
      },
      queryParams: undefined,
      pathParams: undefined,
    });
  };

  return (
    <IgDialog
      title={"Set Your Domain"}
      handleClose={(reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          dialog.close();
        }
      }}
      showDialog={dialog.isOpen}
      showCloseIcon={false}
      dialogContentWidth={"400px"}
      dialogHeight={null}
      maxWidth={"md"}
      loading={patchOrganization.isPending}
      handleYesClick={handleYesClick}
      yesButtonDisabled={error}
      yesButtonText={"Save"}
      noButtonText={"Later"}
      rawContent={
        <Grid container direction={"column"} rowSpacing={1}>
          <Grid>
            <IgTypography>
              What URL do your customers visit to view your site?
            </IgTypography>
          </Grid>
          <Grid>
            <IgTextField
              value={url}
              onChange={(e) => handleChange(e.target.value)}
              fullWidth={true}
            />
            {error ? (
              <IgTypography
                color={theme.palette.text.tonal.error}
                variant={"body2"}
              >
                Invalid URL format
              </IgTypography>
            ) : null}
          </Grid>
          <Grid>
            <IgTypography>
              This may be changed later in the settings page.
            </IgTypography>
          </Grid>
        </Grid>
      }
    />
  );
};
